import React from "react";
import UtilizationModule from "./utilizationModule";
import UtilizationSagas from "./redux/sagas/utilization";
import UtilizationReducer from "./redux/reducers/utilization";
import PageWithConfigurator from "../../shared/pageWithConfigurator/pageWithConfigurator";
import AIAgent from "../ai";

const pageConfig = {
  pageName: "Utilization",
  moduleList: [
    {
      Component: UtilizationModule,
      moduleName: "utilization",
      saga: UtilizationSagas(),
      reducer: UtilizationReducer
    }
  ],
  hideConfigurator: true
};

const UtilizationPage = ({ notifications, objectId }) => {
  return (
    <PageWithConfigurator
      pageConfig={pageConfig}
      notifications={notifications}
      renderAI={() => <AIAgent pageName="utilization" widget objectId={objectId} />}
    />
  );
};

export default UtilizationPage;
